"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LobbyPlayerState = void 0;
var LobbyPlayerState;
(function (LobbyPlayerState) {
    LobbyPlayerState["Pending"] = "pending";
    LobbyPlayerState["AskForReady"] = "ask_for_ready";
    LobbyPlayerState["Ready"] = "ready";
    LobbyPlayerState["AskForRefund"] = "ask_for_refund";
    LobbyPlayerState["Refunded"] = "refunded";
})(LobbyPlayerState || (exports.LobbyPlayerState = LobbyPlayerState = {}));
